export function saveVoucher(state) {
  return {
    type: 'SAVE_VOUCHER',
    payload: state
  }
}
export function clearVoucher() {
  return {
    type: 'CLEAR_VOUCHER'
  }
}
